export const removedChannels = ["WhatsApp", "Cortana", "Crisp"];
